import http, { Http } from '@/lib/http';

interface PaymentAddress {
  zipCode?: string;
  country?: string;
  street?: string | null;
  complement?: string | null;
  region?: string | null;
}

interface PaymentMethodCard extends PaymentAddress {
  cvv: string;
  brand: string;
  lastFourDigits: string;
  expirationMonth: string;
  expirationYear: string;
  type: string;
}

interface PaymentMethodBank extends PaymentAddress {
  routingNumber: string;
  accountNumber: string;
  accountType: string;
  type: string;
}

type PaymentDetails = PaymentMethodCard | PaymentMethodBank;

interface OrderSummary {
  id: string;
  origin: string;
  currency: string;
  amount: string;
  status: string;
  electiveFee: string;
  netPayout: string;
  totalPaid: string;
  totalOwing: string;
  term: number;
}

interface OrderPayment {
  id: string;
  status: string;
  dueDate: Date;
  date: Date | null;
  amount: string;
  type: string;
  isEditable: boolean;
}

interface OrderTimeline {
  eventAt: string;
  eventType: string;
}

interface OrderProduct {
  productId: string;
  productName: string;
  productQuantity: number;
  productPriceAmount: string;
  productTaxAmount: string;
  productTotalAmount: string;
}

interface OrderCheckoutSummary {
  products: OrderProduct[];
  totalAmount: string;
}

interface OrderDetails {
  checkoutName: string;
  merchantName: string;
  merchantId: string;
  reversalDate: string | null;
}

interface OrderCustomerDetails {
  customerId: string;
  customerName: string;
  customerFirstName: string;
  customerLastName: string;
  customerEmail: string;
  customerPhoneNumber: string;
}

export interface GetLoanResponse {
  summary: OrderSummary;
  timeline: OrderTimeline[];
  checkoutSummary: OrderCheckoutSummary;
  payments: OrderPayment[];
  paymentDetails?: PaymentDetails;
  details: OrderDetails;
  customerDetails: OrderCustomerDetails;
  enableOffSchedulePayment: boolean;
}

type Args = {
  projectId: string;
  orderId: string;
};

function ctor(http: Http) {
  return async ({ orderId, projectId }: Args): Promise<GetLoanResponse> => {
    const { data } = await http.get(`/projects/${projectId}/loans/${orderId}`, {});
    return data;
  };
}

export const getLoan = ctor(http);
